import { faHome as faHomeRegular } from '@fortawesome/pro-regular-svg-icons';
import { faHome as faHomeSolid } from '@fortawesome/pro-solid-svg-icons';
import { Box } from '@modusign/design-system';

import GNBLinkButtonIcon from '@app/containers/GlobalNavigationBar/GNBLinkButtonIcon';
import { useInvalidateDocumentList } from '@app/routes/Documents/useDocumentList';

import GlobalNavigationBarMenu from '../GlobalNavigationBarMenu';

function HomeSection() {
  return (
    <Box as="section" p={0}>
      <HomeLink />
    </Box>
  );
}

function HomeLink() {
  const invalidate = useInvalidateDocumentList();

  return (
    <GlobalNavigationBarMenu
      leftIcon={<GNBLinkButtonIcon icon={faHomeRegular} />}
      leftIconActive={<GNBLinkButtonIcon icon={faHomeSolid} />}
      to="/"
      onClick={invalidate}
    >
      홈
    </GlobalNavigationBarMenu>
  );
}

export default HomeSection;
